import i18n from "@/i18n";

export default {
  params: ["target"],
  validate(value, { target }) {
    return new Date(Date.parse(value)) >= new Date(Date.parse(target));
  },
  message: i18n.t("integrations.error.greater_then_start_at")
};
